import { ReactComponent as AddIcon } from '$icons/Add.svg';
import { ReactComponent as CloseIcon } from '$icons/CloseGreen.svg';
import { ReactComponent as RightArrow } from '$icons/ArrowRight.svg';
import Button from '$components/Buttons/Button';
import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import { useState } from 'react';
import { successHandler } from '$store/utils';

const VideoPrompt = () => {
  const [openPromptModal, setOpenPromptModal] = useState(false);
  const [showGeneratedLink, setShowGeneratedLink] = useState(false);
  const [videoPrompt, setVideoPrompt] = useState({ text: '', encoded: '' });
  const closeModalHandler = () => {
    setOpenPromptModal(false);
  };
  return (
    <>
      <Button
        bgColor="#006789"
        showText
        text="Generate Prompt"
        icon={AddIcon}
        invertTextContent
        styling="px-4 whitespace-nowrap"
        onClick={() => {
          setOpenPromptModal((prev) => !prev);
          setShowGeneratedLink(false);
        }}
      />
      <ModalInTailwind isOpen={openPromptModal} closeModal={closeModalHandler}>
        <div className="flex flex-col bg-white p-8 w-2/5">
          <header className="flex flex-row justify-between items-center mb-8 w-full">
            <div className="text-xl font-bold whitespace-nowrap">
              Generate a Video Prompt
            </div>
            <button
              aria-label="Close"
              type="button"
              onClick={closeModalHandler}
            >
              <CloseIcon />
            </button>
          </header>
          {!showGeneratedLink ? (
            <div className="flex flex-col w-full">
              <h3 className="text-lg font-semibold">
                Write the Candidate Prompt
              </h3>
              <textarea
                data-testid="video-prompt-textarea"
                value={videoPrompt.text}
                onChange={(ev) => {
                  setVideoPrompt({
                    text: ev.target.value,
                    encoded: `${
                      process.env.REACT_APP_SPK_URL
                    }/record-video?title=${btoa(ev.target.value)}`,
                  });
                }}
                className="border rounded w-full min-h-40 p-2"
                placeholder={`Type your prompt for the Video you want the candidates to answer here. This will create a link you can share with candidates via Whatsapp or email.
                
Whatever you write here will be what the candidates see.`}
              />
              <div className="flex flex-row mt-4 self-end w-60">
                <Button
                  text="Cancel"
                  showText
                  textStyles={{ color: '#079e88' }}
                  onClick={closeModalHandler}
                />
                <Button
                  text="Generate"
                  icon={RightArrow}
                  invertTextContent
                  showText
                  bgColor="#079e88"
                  disabled={!videoPrompt.text}
                  customStyles={!videoPrompt.text && { opacity: '.25' }}
                  onClick={() => setShowGeneratedLink(true)}
                />
              </div>
            </div>
          ) : (
            <div className="flex flex-col">
              <h3 className="font-bold text-lg">Link</h3>
              <input
                readOnly
                value={videoPrompt.encoded}
                className="border rounded w-full p-2 bg-internal-main/25 outline-none mb-2"
                data-testid="video-prompt-result"
              />
              <div className="self-end flex flex-row w-60">
                <Button
                  text="Cancel"
                  showText
                  textStyles={{ color: '#079e88' }}
                  onClick={closeModalHandler}
                />
                <Button
                  text="Copy Link"
                  showText
                  bgColor="#079e88"
                  onClick={async () => {
                    await navigator.clipboard.writeText(videoPrompt.encoded);
                    successHandler('Copied to Clipboard', true);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </ModalInTailwind>
    </>
  );
};
export default VideoPrompt;
